module.exports = __webpack_public_path__ + "static/pic02-1ceac9adffb747ca966be0c83424e91b.jpg";